import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'agenda',
    loadChildren: () => import('./agenda/agenda.module').then(m => m.AgendaPageModule)
  },
  {
    path: 'anio-mes-modal',
    loadChildren: () => import('./anio-mes-modal/anio-mes-modal.module').then(m => m.AnioMesModalPageModule)
  },
  {
    path: 'cita-disponible',
    loadChildren: () => import('./cita-disponible/cita-disponible.module').then(m => m.CitaDisponiblePageModule)
  },
  {
    path: 'cancelar-cita',
    loadChildren: () => import('./cancelar-cita/cancelar-cita.module').then(m => m.CancelarCitaPageModule)
  },
  {
    path: 'asignar-solicitante',
    loadChildren: () => import('./asignar-solicitante/asignar-solicitante.module').then(m => m.AsignarSolicitantePageModule)
  },
  {
    path: 'asistir',
    loadChildren: () => import('./asistir/asistir.module').then(m => m.AsistirPageModule)
  },
  { path: 'login', loadChildren: './login/login.module#LoginPageModule' },
  { path: 'agenda', loadChildren: './agenda/agenda.module#AgendaPageModule' },
  { path: 'asistir', loadChildren: './asistir/asistir.module#AsistirPageModule' },
  {
    path: 'facturas-modal',
    loadChildren: () => import('./facturas-modal/facturas-modal.module').then( m => m.FacturasModalPageModule)
  },
  {
    path: 'agendar-sin-cita',
    loadChildren: () => import('./agendar-sin-cita/agendar-sin-cita.module').then( m => m.AgendarSinCitaPageModule)
  },
  {
    path: 'buscador-citas',
    loadChildren: () => import('./buscador-citas/buscador-citas.module').then( m => m.BuscadorCitasPageModule)
  },
  {
    path: 'pre-consulta-form',
    loadChildren: () => import('./pre-consulta-form/pre-consulta-form.module').then( m => m.PreConsultaFormPageModule)
  },
  {
    path: 'pre-consulta',
    loadChildren: () => import('./pre-consulta/pre-consulta.module').then( m => m.PreConsultaPageModule)
  },
  {
    path: 'bloqueo-citas',
    loadChildren: () => import('./bloqueo-citas/bloqueo-citas.module').then( m => m.BloqueoCitasPageModule)
  },


];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
